export default "__VITE_ASSET__ukAZzsfu__"